import styled from 'styled-components';

export const StyledNameContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
`;

export const StyledInsuranceImage = styled.img`
    overflow: hidden;
    height: 50px;
    width: 50px;
    max-height: 50px;
    max-width: 50px;
    min-height: 50px;
    min-width: 50px;
`;
export const StyledInsuranceNameContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-left: 16px;
`;
export const StyledInsuranceName = styled.div(
    (p) => `
    max-width: 400px;
    color: ${p.theme.colors.black};
    font-size: ${p.theme.fontSizes.heading};
    font-weight: 700;    
`
);
export const StyledInsuranceCategory = styled.div(
    (p) => `
    color: ${p.theme.colors.muted};
    font-size: ${p.theme.fontSizes.label};
    margin-top: 8px;
    font-weight: 600;
    text-transform: uppercase;
`
);
